<template>
  <div>
    <b-container class="container card">
      <!-- search -->
      <div id="search" v-if="search" class="card">
        <div class="card-header">
          <div>
            <i class="fa fa-search"></i>
            <span>بحث</span>
          </div>
        </div>
        <div class="card-body">
          <div class="container">
            <div class="form row card-search">
              <div class="form-group col-md-3">
                <label for="">كود السند</label>
                <input type="text" class="form-control" v-model="s_id" />
              </div>
                <div class="form-group col-md-3">
                <label for="">الفصل الدراسى</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_classyears"
                >
                  <option
                    v-for="cls in classY"
                    :value="cls.id"
                    :key="cls.id"
                  >
                    <span> {{ cls.classs }} </span>
                    <span> {{ cls.classyear }} </span>
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label for="">جهة التحصيل</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_accType"
                >
                  <option
                    v-for="acc in accountType.filter((t) => t.accountType == 1)"
                    :value="acc.id"
                    :key="acc.id"
                  >
                    <span> {{ acc.accountName }} </span>
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3 ">
                <label for=""> تاريخ التحصيل</label>
                <div class="form-inline">
                  <select
                    name=""
                    id="lcStart"
                    class="col-md-3 select-par"
                    v-model="lcStart"
                  >
                    <option value="1"><span>اكبر من</span></option>
                    <option value="2"><span>اصغر من</span></option>
                    <option value="3"><span>يساوى</span></option>
                  </select>
                  <input
                    id="id_payDate"
                    type="text"
                    @blur="s_payDate1"
                    class="form-control hijri-date-input col-md-9"
                    v-bind:value="s_payDate"
                  />
                </div>
              </div>

              <div class="form-group col-md-3">
                <label for="">كود الباص</label>
                <input type="text" class="form-control" v-model="s_busID" />
              </div>

              <div class="form-group col-md-3">
                <label for="">كود الطالب/ة</label>
                <input type="text" class="form-control" v-model="s_stdID" />
              </div>

              <div class="form-group col-md-3">
                <label for="">نوع القبض</label>
                <select name="" id="" class="col-12" v-model="s_payType">
                  <option value="1">كاش</option>
                  <option value="2">شيك</option>
                </select>
              </div>
              <div class="form-group col-md-3 p-4">
                <button @click="clear" class="btn btn-danger">
                  الغاء البحث
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- **************************** crud  **********************************-->
      <div id="crud" v-if="crud" class="card">
        <div v-if="add" class="card-header bg-primary ">
          <div>
            <i class="fa fa-plus"></i>
            <span>إضافة</span>
          </div>
        </div>
        <div v-if="edit" class="card-header bg-warning">
          <div>
            <i class="fa fa-pen-nib"></i>
            <span>تعديل</span>
          </div>
        </div>
        <form action="" @submit.prevent="submit">
          <div class="card-body">
            <div class="container">
              <div class="form row card-search">
                <div class="form-group col-md-3">
                  <label for="">كود السند</label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model.trim="$v.id.$model"
                    :class="{
                      'is-invalid': $v.id.$error,
                      'is-valid': !$v.id.$invalid,
                    }"
                  />
                  <div class="invalid-feedback"></div>
                </div>
 <div class="form-group col-md-3">
                  <label for="">الفصل الدراسى</label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.classyears.$model"
                    :class="{
                      'is-invalid': $v.classyears.$error,
                      'is-valid': !$v.classyears.$invalid,
                    }"
                  >
                    <option
                      v-for="act in classY"
                      :value="act.id"
                      :key="act.id"
                    >
                      <span> {{ act.classs }} </span>
                    <span> {{ act.classyear }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.classyears.required">هذا الحقل مطلوب</span>
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label for="">جهة التحصيل</label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.accType.$model"
                    :class="{
                      'is-invalid': $v.accType.$error,
                      'is-valid': !$v.accType.$invalid,
                    }"
                  >
                    <option
                      v-for="act in accountType.filter((t) => t.accountType == 1)"
                      :value="act.id"
                      :key="act.id"
                    >
                      <span> {{ act.accountName }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.accType.required">هذا الحقل مطلوب</span>
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label for="">الاسم</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.payName.$model"
                    :class="{
                      'is-invalid': $v.payName.$error,
                      'is-valid': !$v.payName.$invalid,
                    }"
                  />
                  <div class="invalid-feedback">
                    <span v-if="!$v.payName.required">هذا الحقل مطلوب</span>
                    <span v-if="!$v.payName.minLength"
                      >يجب ان يحتوى على الاقل على{{
                        $v.payName.$params.minLength.min
                      }}</span
                    >
                    <span v-if="!$v.payName.maxLength"
                      >اقصى عدد مسموح {{ $v.payName.$params.maxLength.max }} حرف
                    </span>
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label for="">تاريخ التحصيل</label>

                  <input
                    id="payDateee"
                    type="text"
                    @blur="payDate1"
                    class="form-control hijri-date-input"
                    v-bind:value="$v.payDate.$model"
                    :class="{
                      'is-invalid': $v.payDate.$error,
                      'is-valid': !$v.payDate.$invalid,
                    }"
                  />
                  <div class="invalid-feedback">
                    <span v-if="!$v.payDate.required">هذا الحقل مطلوب</span>
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label for="">الطالب /ة</label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.stdID.$model"
                    :class="{
                      'is-invalid': $v.stdID.$error,
                      'is-valid': !$v.stdID.$invalid,
                    }"
                  >
                    <option v-for="std in stds" :value="std.id" :key="std.id">
                      <span> {{ std.Fname }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.stdID.required">هذا الحقل مطلوب</span>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">كود الباص</label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.busID.$model"
                    :class="{
                      'is-invalid': $v.busID.$error,
                      'is-valid': !$v.busID.$invalid,
                    }"
                  >
                    <option v-for="bus in buses" :value="bus.id" :key="bus.id">
                      <span> {{ bus.id }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.busID.required">هذا الحقل مطلوب</span>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">التفاصيل</label>
                  <textarea
                    type="text"
                    class="form-control"
                    v-model.trim="$v.Details.$model"
                    :class="{
                      'is-invalid': $v.Details.$error,
                      'is-valid': !$v.Details.$invalid,
                    }"
                  />
                  <div class="invalid-feedback"></div>
                </div>
                  <div class="form-group col-md-3">
                  <label for="">الى حساب</label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.ToAccount.$model"
                    :class="{
                      'is-invalid': $v.ToAccount.$error,
                      'is-valid': !$v.ToAccount.$invalid,
                    }"
                  >
                    <option
                      v-for="box in boxes"
                      :value="box.id"
                      :key="box.id"
                    >
                      <span> {{ box.accountName }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.ToAccount.required">هذا الحقل مطلوب</span>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">نوع التحصيل</label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.payTypee.$model"
                    :class="{
                      'is-invalid': $v.payTypee.$error,
                      'is-valid': !$v.payTypee.$invalid,
                    }"
                  >
                    <option
                      v-for="pty in payType"
                      :value="pty.id"
                      :key="pty.id"
                    >
                      <span> {{ pty.pType }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.payTypee.required">هذا الحقل مطلوب</span>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">رقم الشيك</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.check.$model"
                    :class="{
                      'is-invalid': $v.check.$error,
                      'is-valid': !$v.check.$invalid,
                    }"
                  />
                  <div class="invalid-feedback"></div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">المبلغ</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.trim="$v.amount.$model"
                    :class="{
                      'is-invalid': $v.amount.$error,
                      'is-valid': !$v.amount.$invalid,
                    }"
                  />
                  <div class="invalid-feedback">
                    <span v-if="!$v.amount.required">هذا الحقل مطلوب</span>
                  </div>
                </div>
              </div>

              <div v-if="add" class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      style="background-color:#007bff !important;"
                      class="col-md-6 btn-primary"
                      type="submit"
                      :disabled="busy"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{addEdit}}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="cancelCrud"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
              <div v-if="edit" class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      class="col-md-6 btn-warning"
                      type="submit"
                      :disabled="busy"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{addEdit}}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="hideModal"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ul class="nav nav-tabs view-mode">
        <li class="nav-item ">
          <a class="nav-link active" data-toggle="tab" href="#home">
            <i class="fa fa-table"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#menu1">
            <i class="fa fa-bars"></i>
          </a>
        </li>
      </ul>
      <!-- **************************** add button **********************************-->
      <div class="m-auto">
        <b-button v-if="c_add" @click="insert" variant="outline-primary">إضافة</b-button>
        <div class="std-count">
          <span class="text-danger">
            عدد السندات
          </span>
          <span> | </span>
          <span class="text-success"> {{ items.length }} </span>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab-pane container active overflow" id="home">
          <!-- Main table element -->

          <b-table
            :busy="isBusy"
            :bordered="true"
            :no-border-collapse="true"
            show-empty
            striped
            hover
            small
            stacked="sm"
            :fields="fields"
            :current-page="currentPage"
            :per-page="10"
            :items="filtered"
            head-variant="dark"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            sort-icon-left
          >
            <template v-slot:head(id) style="background-color:red;">
              <span class="text-info">كود السند</span>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> جارى التحميل ... </strong>
              </div>
            </template>
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'id' ? '20px' : '20px' }"
              />
            </template>
            <template slot="top-row" slot-scope="{ fields }">
              <td v-for="field in fields" :key="field.key">
                <input
                  v-model="filters[field.key]"
                  :placeholder="field.label"
                />
              </td>
            </template>
            <template v-slot:cell(actions)="row">
                 <b-button
                 v-if="c_print"
                size="sm"
                @click="print(row.item)"
                class="mr-1"
                variant="outline-success"
              >
                طباعة
              </b-button>
              <b-button
              v-if="c_update"
                size="sm"
                @click="update(row.item, row.index, $event.target)"
                class="mr-1"
                variant="outline-warning"
              >
                تعديل
              </b-button>
              <b-button
              v-if="c_delete"
                size="sm"
                @click="info(row.item, row.index, $event.target)"
                class="mr-1"
                variant="outline-danger"
              >
                حذف
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col sm="7" md="6" class="m-auto">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class=""
              ></b-pagination>
            </b-col>
          </b-row>
          <!-- Info modal -->
          <b-modal
            :id="infoModal.id"
            hide-footer
            ref="my-modal"
            body-bg-variant="light"
            body-text-variant="danger"
            footer-bg-variant="warning"
            footer-text-variant="light"
            @hide="resetInfoModal"
          >
            <div class="d-block text-center">
              <b-row>
                <div class="card-body">
                  <span>
                    هل انت متأكد من حذف السند رقم <span class="text-primary">{{ delitem.id }}</span> ؟
                  </span>
                  <span class="text-dark">{{ delitem.boardNum }}</span>
                </div>
              </b-row>
              <div class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      class="col-md-6 btn-danger"
                      :disabled="busy"
                      @click="remove(delitem)"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{ btnDelMessage }}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="hideModal"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
            </div>
          </b-modal>
          <!-- Add/update -->
          <b-modal
            id="updateModal"
            hide-footer
            ref="my-modal"
            body-bg-variant="light"
            body-text-variant="danger"
            footer-bg-variant="warning"
            footer-text-variant="light"
            @hide="resetInfoModal"
          >
            <div class="d-block text-center"></div>
          </b-modal>
        </div>
        <div class="tab-pane container fade" id="menu1">
          <div class="container">
            <div class="row">
              <div class="col-md-3" v-for="item in items" :key="item.id">
                <div class="itm card">
                  <div class="card-header">
                    <span>كود السند</span>
                    <span> | </span>
                    <span class="text-warning"> {{ item.id }} </span>
                  </div>
                  <table>
                
                    <tr>
                      <td>جهة التحصيل</td>
                      <td>|</td>
                      <td>{{ item.accountName }}</td>
                    </tr>
                    <tr>
                      <td>تاريخ التحصيل</td>
                      <td>|</td>
                      <td>{{ item.payDate }}</td>
                    </tr>
                    <tr>
                      <td>الاسم</td>
                      <td>|</td>
                      <td>{{ item.payName }}</td>
                    </tr>
                    <tr>
                      <td>كود الطالب</td>
                      <td>|</td>
                      <td>{{ item.stdID }}</td>
                    </tr>
                    <tr>
                      <td>اسم الطالب</td>
                      <td>|</td>
                      <td>{{ item.fullName }}</td>
                    </tr>
                    <tr>
                      <td>كود الباص</td>
                      <td>|</td>
                      <td>{{ item.busID }}</td>
                    </tr>
                    <tr>
                      <td>نوع القبض</td>
                      <td>|</td>
                      <td>{{ item.pType }}</td>
                    </tr>
                    <tr>
                      <td>البملغ</td>
                      <td>|</td>
                      <td>{{ item.amount }}</td>
                    </tr>
                  </table>

                  <div class="card-footer m-auto">
                   <b-button
                 v-if="c_print"
                size="sm"
                @click="print(item)"
                class="mr-1"
                variant="outline-success"
              >
                طباعة
              </b-button>
                    <b-button
                    v-if="c_update"
                      size="sm"
                      class="mr-1"
                      @click="update(item)"
                      variant="outline-warning"
                    >
                      تعديل
                    </b-button>
                    <b-button
                    v-if="c_delete"
                      size="sm"
                      @click="infoDel(item.id)"
                      class="mr-1"
                      variant="outline-danger"
                    >
                      حذف
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import indexLayout from "../../layouts/indexLayout.vue";
import $ from "jquery";
export default {
  name: "income",
  data() {
    return {
      s_id: "",
      s_accType: "",
      s_payDate: "",
      s_busID: "",
      s_stdID: "",
      s_payType: "",
      s_classyears:"",
      id: "",
      payName: "",
      payDate: "",
      accType: "",
      stdID: "",
      Details: "",
      busID: "",
      payTypee: "",
      ToAccount:"",
      check: "",
      amount: "",
      classyears:"",
      lcStart: "",
      cardName: "",
      search: true,
      crud: false,
      add: false,
      edit: false,
      isBusy: true,
      busy: false,
      addEdit:null,
      btnDelMessage: "حذف",
      items: [],
      delitem: "",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "warning",
      footerTextVariant: "dark",
          /*check role */
c_add:false,
c_update:false,
c_delete:false,
c_print:false,

/*check end */
      fields: [
        {
          key: "id",
          label: "كود السند",
          sortable: true,
          class: "f-id",
          sortDirection: "desc",
          tdClass: "fid",
        },
        {
          key: "fullName",
          label: "اسم الطالب",
          sortable: true,
          class: "text-center",
        },
        {
          key: "busID",
          label: "رقم الباص",
          sortable: true,
          class: "text-center",
        },
        {
          key: "amount",
          label: "المبلغ",
          sortable: true,
          class: "text-center",
        },

        { key: "actions", label: "" },
      ],
      filters: {
        id: "",
        payName: "",
        payDate: "",
        accType: "",
        stdID: "",
        Details: "",
        busID: "",
        payType: "",
        check: "",
        amount: "",
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  validations: {
    id: {},
    payName: { required, minLength: minLength(2), maxLength: maxLength(25) },
    payDate: {
      required,
      isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
      },
    },
    accType: { required },
    stdID: { required },
    Details: {},
    busID: { required },
    payTypee: { required },
    classyears: { required },
    ToAccount: { required },
    check: {},
    amount: { required },
  },
    created(){
      this.$emit('update:layout',indexLayout)
      this.Role_check();
    },
  computed: {
    ...mapGetters({
      load: "payMod/GET_ALLDATA",
      stds: "stdMod/GET_STDALL",
      classY: "classesMod/GET_ALLDATA",
      checkR : "GET_ROLES"
    }),
    ...mapState(["accountType", "payType", "buses","boxes"]),

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    filtered() {
      const filtered = this.items.filter((item) => {
        return Object.keys(this.filters).every((key) =>
          String(item[key]).includes(this.filters[key])
        );
      });
      return filtered.length > 0
        ? filtered
        : [
            {
              id: "",
              payName: "",
              payDate: "",
              accType: "",
              stdID: "",
              Details: "",
              busID: "",
              payType: "",
              check: "",
              amount: "",
            },
          ];
    },
  },
  mounted() {
    this.getData();
   this.loadDatePicker();
  },
  methods: {
    ...mapActions({
      loadData: "payMod/fetchData",
      addData: "payMod/addData",
      updateData: "payMod/updateData",
      deleData: "payMod/deleteData",
    }),
    insert: function() {
      this.addEdit = "إضافة";
      this.$v.$reset();
      this.clearCrud();
      this.search = false;
      this.crud = true;
      this.add = true;
      this.edit = false;
     window.scrollTo(0, 0)
    this.loadDatePicker();
    },
    update(item) {
      this.addEdit = "تعديل";
      this.delitem = item;
      this.search = false;
      this.crud = true;
      this.add = false;
      this.edit = true;
      this.editLood();
      window.scrollTo(0, 0)
      this.loadDatePicker();
    },
    s_payDate1() {
      var st = $("#id_payDate").val();
      this.s_payDate = st;
      // this.Cfilter();
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.delitem = item;
      this.search = true;
      this.crud = false;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    payDate1() {
      var st = $("#payDateee").val();
      this.payDate = st;
    },

    infoDel: function(id) {
      var item = this.items.find((todo) => todo.id == id);
      this.infoModal.title = item.id;
      this.delitem = item;
      this.search = true;
      this.crud = false;
this.$root.$emit("bv::show::modal", this.infoModal.id);
    },
    async remove(stdRow) {
      this.busy = true;
      await this.deleData(stdRow);
      this.btnDelMessage = "تم الحذف";
      this.busy = false;
      this.items = this.load;
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "خطأ";
      } else {
        var std = {
          id: this.id,
          payName: this.payName,
          payDate: this.payDate,
          accType: this.accType,
          stdID: this.stdID,
          Details: this.Details,
          busID: this.busID,
          payType: this.payTypee,
          ToAccount: this.ToAccount,
          check: this.check,
          classyears: this.classyears,
          amount: this.amount,
        };
        this.busy = true;
        if (this.add == true) {
          await this.addData(std);
           var state1= this.$store.getters['payMod/getMsg'];
         if(state1 <= 201){
          this.search = true;
          this.crud = false;
          this.loadDatePicker();
          this.items = this.$store.getters['payMod/GET_ALLDATA'];
          this.addEdit = "تم الاضافة";
         }else{
           this.addEdit = "خطأ";
         }
         
        }
        if (this.edit == true) {
         await this.updateData(std);
         var state2= this.$store.getters['payMod/getMsg'];
         if(state2 <= 201){
          this.search = true;
          this.crud = false;
          this.loadDatePicker();
          this.items = this.$store.getters['payMod/GET_ALLDATA'];
          this.addEdit = "تم التعديل";
         }else{
           this.addEdit = "خطأ";
         }
               
        }

        this.submitStatus = "الانتظار";
        setTimeout(() => {
          this.busy = false;
          this.submitStatus = "تم الحفظ";
        }, 500);
      }
    },cancelCrud() {
      this.search = true;
      this.crud = false;
      this.loadDatePicker();
    },
    hideModal() {
      this.search = true;
      this.crud = false;
      this.loadDatePicker();
      this.$root.$emit("bv::hide::modal", this.infoModal.id);
    },
    clearCrud() {
      this.s_id = "";
      this.s_accType = "";
      this.s_payDate = "";
      this.s_busID = "";
      this.s_stdID = "";
      this.s_payType = "";
      this.s_classyears = "";
      this.id = "";
      this.payName = null;
      this.payDate = null;
      this.accType = null;
      this.stdID = null;
      this.Details = null;
      this.busID = null;
      this.payTypee = null;
      this.ToAccount = null;
      this.check = null;
      this.amount = null;
      this.s_classyears = null;
    },
    editLood() {
      this.s_id = "";
      this.s_accType = "";
      this.s_payDate = "";
      this.s_busID = "";
      this.s_stdID = "";
      this.s_payType = "";
       this.s_classyears = "";
      this.id = this.delitem.id;
      this.payName = this.delitem.payName;
      this.payDate = this.delitem.payDate;
      this.accType = this.delitem.accType;
      this.stdID = this.delitem.stdID;
      this.Details = this.delitem.Details;
      this.busID = this.delitem.busID;
      this.payTypee = this.delitem.payType;
      this.ToAccount = this.delitem.ToAccount;
      this.check = this.delitem.check;
      this.classyears = this.delitem.classyears;
      this.amount = this.delitem.amount;
    },
    async getData() {
      await this.$store.dispatch("payMod/fetchData");
        this.items = this.load;
        this.totalRows = this.items.length;
        this.isBusy = false;

      // if (this.load.length > 0) {
      //   this.items = this.load;
      //   this.totalRows = this.items.length;
      //   this.isBusy = false;
      // } else {
      //   await this.$store.dispatch("payMod/fetchData");
      //   this.items = this.load;
      //   this.totalRows = this.items.length;
      //   this.isBusy = false;
      // }
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Cfilter() {
      this.items = this.load;
      this.items = this.items.filter((t) =>
        t.id.toString().includes(this.s_id)
      );

      this.items = this.items.filter((t) =>
        t.accType.toString().includes(this.s_accType)
      );

      this.items = this.items.filter((t) =>
        t.busID.toString().includes(this.s_busID)
      );
      this.items = this.items.filter((t) =>
        t.stdID.toString().includes(this.s_stdID)
      );
      this.items = this.items.filter((t) =>
        t.payType.toString().includes(this.s_payType)
      );
      if (this.s_payDate != "") {
        if (this.lcStart == 1) {
          this.items = this.items.filter((t) => t.payDate >= this.s_payDate);
        } else if (this.lcStart == 2) {
          this.items = this.items.filter((t) => t.payDate <= this.s_payDate);
        } else if (this.lcStart == 3) {
          this.items = this.items.filter((t) => t.payDate == this.s_payDate);
        }
      }
    },
    clear() {
      this.s_id = "";
      this.s_accType = "";
      this.s_payDate = "";
      this.s_busID = "";
      this.s_stdID = "";
      this.s_payType = "";
      this.s_classyears = "";
    },loadDatePicker(){
     let ckeditor = document.createElement("script");
    ckeditor.innerHTML = "$(function () { initHijrDatePicker();  });";
    document.body.appendChild(ckeditor);
    },
    print(items){
      this.$router.push({ name: 'bill' ,params: {items : items} })
    },
      Role_check(){
this.c_add =this.checkR.income_add ==1 ? true : false;
this.c_update =this.checkR.income_update ==1 ? true : false;
this.c_delete =this.checkR.income_delete ==1 ? true : false;
this.c_print =this.checkR.income_print ==1 ? true : false;

}
  },
  watch: {
    s_id: function() {
      this.Cfilter();
    },
    s_accType: function() {
      this.Cfilter();
    },
    s_payDate: function() {
      this.Cfilter();
    },
    s_busID: function() {
      this.Cfilter();
    },
    s_stdID: function() {
      this.Cfilter();
    },
    s_payType: function() {
      this.Cfilter();
    },
  },
};
</script>
<style lang="scss" scoped>
.b-table-top-row > td:last-child {
  visibility: hidden;
}
.nav-link.active {
  background-color: #ddab2b !important;
}
.fid {
  background-color: #ddab2b;
}
.itm {
  margin: 10px 0px;
  box-shadow: 0px 0px 6px 1px black;
  -moz-box-shadow: 0px 0px 6px 1px black;
  -o-box-shadow: 0px 0px 6px 1px black;
  -webkit-box-shadow: 0px 0px 6px 1px black;
}
.dropdown-menu {
  z-index: 1600 !important; /* has to be larger than 1050 */
}
</style>
